module.exports = __webpack_public_path__ + "static/media/Grupo 350@2x.e1cd9df9.png";